import { jsonParseSafe } from "@gr-common/head/json";
import { macrotasks } from "@otto-ec/assets-core-utils/test-utils";
import type { OnexData } from "./index.js";

/**
 *
 */
interface OnexDataRaw {
  onexes?: (OnexEntryRaw | undefined)[];
}

interface OnexEntryRaw {
  n: string;
  v: string;
}

declare global {
  interface Window {
    /**
 *
 *
 */
    __onex__?: OnexData;

    /**
 *
 */
    __onex_raw__?: OnexDataRaw;
  }
}

/**
 *
 *
 *
 *
 *
 */
export function transformAndAssignOnexData(
  data: OnexDataRaw | undefined | null = window.__onex_raw__,
): OnexData {
  /*                                                        */
  if (!data) return {};

  /*                                             */
  const { onexes = [] } = data;
  const onexData = Object.fromEntries(
    onexes.map((onex) => (onex ? ([onex.n, onex.v] as const) : undefined)).filter(Boolean),
  );

  /*                                                                             */
  window.__onex__ = onexData;
  return onexData;
}

/**
 *
 *
 *
 *
 *
 */
export async function fetchOnexData(): Promise<void> {
  /*                                        */
  if (window.__onex__) return;

  /*                                                     */
  await macrotasks();

  const response = await fetch(new URL("/onex/assignments/", window.location.href));
  if (!response.ok) return;
  const text = await response.text();
  const data = jsonParseSafe<OnexDataRaw>(text);

  /*                                                    */
  otto.onex.assignments.set(transformAndAssignOnexData(data));
}
